<template>
    <div>
        <div class="d-flex flex-column gap-2 ans-q-container" v-for="(question,idx) in this.template.questions"
             :key="idx">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex flex-column gap-2">
                    <div>Question {{idx+1}}</div>
                    <div class="q-content">{{question['question']}}</div>
                </div>
                <div class="weightStyle">{{question.degree}}</div>
            </div>
            <div>
                <div class=" d-flex flex-column gap-2">
                    <p class="my-0">Answers</p>
                    <div v-if="question['answers'].length > 0" class="d-flex justify-content-between gap-3 my-3 ans-content">
                        <div class="answers-style">
                            <div class="d-flex flex-column gap-3 answers-container">
                                <div v-for="(a,index) in question['answers']"
                                     class="d-flex gap-4 align-items-center">
                                    <div  class="m-c-answer-container position-relative"
                                         :style="{backgroundColor: a.bgColor}">
<!--                                        <input type="text"-->
<!--                                               class="w-100"-->
<!--                                               autocomplete="off"-->
<!--                                               @input="answerTextChangeHandler($event, idx, index ,'arrange')"-->
<!--                                               :placeholder="a.key" v-model="a.value"/>-->

                                        <textarea
                                                class="q-input w-100"
                                                autocomplete="off"
                                                disabled="true"
                                                @input="answerTextChangeHandler($event, idx, index ,'arrange')"
                                                :placeholder="a.key" v-model="a.value">
                                        </textarea>
                                        <!--                                        <span class="delete-answer-icon"-->
                                        <!--                                              @click="deleteAnswerHandler($event, idx, index, 'arrange')">-->
                                        <!--                                        <font-awesome-icon :icon="['fas', 'times']" size="sm"/>-->
                                        <!--                                    </span>-->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="text-center">No Answer</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    export default {
        name: 'arrange-component',
        data() {
            return {
                originalData: {},
                sourceData: {},
                destData: {}
            }
        },
        async mounted() {
        },
        props: ['template', 'userAnswers'],
        methods: {
            changeHandler(e, qidx, aidx) {
                console.log(this.template.freeText[qidx].answers[aidx])
                this.userAnswers.answers.forEach((answer, index) => {

                    if (answer['question_id'] === this.template.freeText[qidx]['answers'][aidx]['question_id']) {
                        this.userAnswers.answers.splice(index, 1);
                    }

                });
                this.userAnswers.answers.push({...this.template.freeText[qidx]['answers'][aidx]});
                console.log(this.userAnswers.answers)
                this.template.changeFlag = true;
            },
            async dragStartHandler(e, data, qIdx, aIdx) {
                console.log({data}, {qIdx}, {aIdx});

                this.originalData = this.template['arrange'][qIdx]['answers'].map((obj) => ({...obj}));
                this.sourceData = {
                    idx: aIdx,
                    order: data.order,
                    value: data.value
                }
            },
            dropHandler(e, data, qIdx, aIdx) {
                console.log("dropHandler => ", {data}, {qIdx}, {aIdx});
                this.template['arrange'][qIdx]['answers'][aIdx]['bgColor'] = "transparent";
                this.originalData = this.template['arrange'][qIdx]['answers'].map((obj) => ({...obj}));
            },
            dragEnterHandler(e, data, qIdx, aIdx) {
                e.preventDefault();
                const index = this.sourceData.idx;
                let sourceValue = null;
                let destValue = null;

                this.destData.idx = aIdx;
                this.template['arrange'][qIdx]['answers'] = this.originalData.map((obj) => ({...obj}));

                if (index !== +aIdx) {
                    sourceValue = this.template['arrange'][qIdx]['answers'][index]['value'];
                    destValue = this.template['arrange'][qIdx]['answers'][aIdx]['value'];

                    this.template['arrange'][qIdx]['answers'][aIdx]['value'] = sourceValue;
                    this.template['arrange'][qIdx]['answers'][index]['value'] = destValue;
                    this.template['arrange'][qIdx]['answers'][aIdx]['bgColor'] = "#034560";
                }
                console.log("dragEnterHandler => ", {data}, {qIdx}, {aIdx}, {sourceValue}, {destValue});
            },
            dragExitHandler(e, data, qIdx, aIdx) {
                // console.log("dragExitHandler ", {data}, {qIdx}, {aIdx},  this.template['arrange'][qIdx]['answers'][this.destData.idx], this.destData, this.sourceData);
                console.log("dragExitHandler ", this.sourceData.idx, this.template['arrange'][qIdx]['answers']);
                console.log("this.userAnswers ", this.userAnswers);
                this.template['arrange'][qIdx]['answers'][this.destData.idx]['bgColor'] = "transparent";
                this.template['arrange'][qIdx]['answers'].forEach((arrAns, idx) => {
                    arrAns.order = idx + 1;
                    this.userAnswers.answers.forEach((ans, index) => {
                        if (+ans.id === +arrAns.id) {
                            this.userAnswers.answers.splice(index, 1);
                        }
                    })
                })


                this.userAnswers.answers.push(...this.template['arrange'][qIdx]['answers']);
                console.log(this.userAnswers.answers)
                this.template.changeFlag = true;
            },
        }
    }
</script>

<style scoped>
    .weightStyle{
        border: 1px solid var(--border-color-profile-icon);
        background-color: var(--tabLinkBackgroundColorTemplate);
        border-radius: 10px;
        padding: 7px;
        height: fit-content;
        width:40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        float: left;
    }

    .q-input {
        /*pointer-events: none;*/
        background-color: transparent !important;
        border: none;
        border-radius: 4px;
        color: var(--main-color);
        padding: 10px;
        overflow-y: auto;
        overflow-x: hidden;
        height: 45px;
        max-height: 60px;
    }

    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 20px;
        padding-bottom: 20px;
    }

    .question-container:last-child {
        border-bottom: none;
    }

    .sort-icon {
        cursor: pointer;
    }

    .answers-style {
        padding: 11px;
        overflow: auto;
        max-height: 270px;
    }

    .m-c-answer-container {
        width: 360px;
        border: 1px solid #39525C;
        border-radius: 8px;
        padding: 8px;
        display: flex;
        color: var(--main-color);
        gap: 4px;
    }

    .m-c-answer-container > input[type=text],
    .m-c-answer-container > input[type=text]:focus,
    .m-c-answer-container > input[type=text]:focus-visible {
        border: 0;
        color: var(--main-color);
        background-color: transparent;
        outline: 0;
        pointer-events: none;
    }

    .delete-answer-icon {
        position: absolute;
        top: -5px;
        right: -4px;
        display: flex;
        background-color: #E95626;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #032a3a;
        cursor: pointer;
    }

</style>